import { AttributeValue, FormSubmission } from 'lib-shared-types-api';

import { FieldSubmission, FormSubmissionData } from '../../customForms.types';

export function formSubmissionConverter(
  formSubmission: FormSubmission,
): FormSubmissionData {
  return {
    submissionId: formSubmission.id,
    formId: formSubmission.form_id,
    formVersion: formSubmission.form_version.toString(),
    submissionData: formSubmission.values.reduce(
      (acc: Record<string, FieldSubmission>, { attribute_id, value }) => {
        acc[attribute_id] = convertAttributeValue(value);
        return acc;
      },
      {},
    ),
  };
}

function convertAttributeValue(x: AttributeValue): FieldSubmission {
  switch (x.data_type) {
    case 'string':
      return {
        type: x.data_type,
        value: x.value,
      };
    case 'string_list':
      return {
        type: 'stringArray',
        value: x.value,
      };
    case 'file_list':
      const { value } = x;
      return {
        type: 'fileArray',
        value: value.map(
          ({ relative_url, name, media_type, bytes_length }) => ({
            relative_url,
            name,
            media_type,
            bytes_length,
          }),
        ),
      };
  }
}
